/// <amd-module name="Agile/Taskboard/CustomColumn/Components/WorkItemStateForm" />
import * as Resources from "Agile/Taskboard/CustomColumn/Resources";
import * as React from "react";
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { Dropdown } from "VSSUI/Dropdown";
import { FormItem } from "VSSUI/FormItem";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

/*****
 * DRAFT : DO NOT REVIEW THIS FILE YET
 */

export type WorkItemStateMapping = { [workItemType: string]: string /** State */ };
export interface IWorkItemStateFormProps {
    availableStates: { [workItemType: string]: string[] /** list of states */ };
    currentMapping: WorkItemStateMapping;
    updateMappings: (mapping: WorkItemStateMapping) => void;
}

export const WorkItemStateForm = (props: IWorkItemStateFormProps) => {
    const sortedWorkItemTypes = Object.keys(props.availableStates).sort(localeIgnoreCaseComparer);
    const [mappings, setMappings] = React.useState(props.currentMapping);

    return (
        <table className="work-item-table">
            <tbody>
                <tr>
                    <td className="work-item">Task</td>
                    <td>
                        <Dropdown
                            placeholder={Resources.None}
                            items={[{ id: "New", text: "New" }, { id: "Active", text: "Active" }, { id: "Done", text: "Done" }]}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const renderWorkItemRow = (props: IWorkItemStateFormProps, workItemType: string, mappings: WorkItemStateMapping) => {
    const [error, setError] = React.useState("");
    const selection = React.useRef(new DropdownSelection());
    const firstRender = React.useRef(true);

    React.useEffect(() => {
        if (firstRender) {
            firstRender.current = false;
            if (mappings[workItemType]) {
                const index = props.availableStates[workItemType].findIndex(s => s === mappings[workItemType]);
                selection.current.value = [
                    {
                        beginIndex: index,
                        endIndex: index
                    }
                ];
            }
        }
        if (selection.current.selectedCount === 0) {
            setError("Please choose a state.");
        }
    }, [selection.current]);

    const dropDownItems = props.availableStates[workItemType].map(state => {
        return { id: state, text: state };
    });

    return (
        <tr>
            <td className="work-item">{workItemType}</td>
            <td>
                <FormItem error={!!error} message={error}>
                    <Dropdown placeholder={Resources.None} items={dropDownItems} selection={selection.current} />
                </FormItem>
            </td>
        </tr>
    );
};
